import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import authSelectors from "~/store/auth/selectors";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import authActionCreators from "~/store/auth/actions";
import { Avatar, Dropdown, Grid, Icon, Modal, Text } from "~/components-shared";
import ProfileStatusUpdateModal from "~/components/ProfileStatusUpdateModal";
import useAbacExt from "~/hooks/abac";
const StyledGridCell = styled(Grid.Cell)`
  overflow: hidden;
  align-self: center;
`;
const StyledText = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const UserDropdown = _ref => {
  let {
    direction = "bottomLeft"
  } = _ref;
  const {
    colors
  } = useTheme();
  const user = useSelector(authSelectors.getUser);
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const history = useHistory();
  const options = [];
  const [statusOpen, setStatusOpen] = useState(false);
  if (!user) {
    return null;
  }
  if (userHas(AuthoritiesEnum.PROFILE_READ)) {
    options.push({
      id: 1,
      name: t("UserDropdown.profile"),
      icon: "profile",
      action: () => history.push(RoutesEnum.PROFILE)
    });
  }
  if (userHas(AuthoritiesEnum.ACCOUNT_SETTINGS_READ)) {
    options.push({
      id: 2,
      name: t("UserDropdown.accountSettings"),
      icon: "cog",
      action: () => history.push(RoutesEnum.ACCOUNT_SETTINGS)
    });
  }
  if (userHas(AuthoritiesEnum.MANAGE_COMPANIES_READ)) {
    options.push({
      id: 3,
      name: /*#__PURE__*/React.createElement(React.Fragment, null, t("UserDropdown.companyManagement"), /*#__PURE__*/React.createElement(Icon, {
        src: "encrypted",
        color: "primary",
        s: {
          ml: 1
        }
      })),
      icon: "people",
      action: () => history.push(RoutesEnum.COMPANY_MANAGEMENT)
    });
  }
  if (userHas(AuthoritiesEnum.MANAGE_MEMBERS_READ)) {
    options.push({
      id: 4,
      name: t("UserDropdown.memberManagement"),
      icon: "people",
      action: () => history.push(RoutesEnum.MEMBER_MANAGEMENT)
    });
  }
  if (userHas(AuthoritiesEnum.MANAGE_ROLES_READ)) {
    options.push({
      id: 5,
      name: t("UserDropdown.roleManagement"),
      icon: "people",
      action: () => history.push(RoutesEnum.ROLE_MANAGEMENT)
    });
  }
  if (userHas(AuthoritiesEnum.ORG_CHART_READ)) {
    options.push({
      id: 6,
      name: t("UserDropdown.orgChart"),
      icon: "tree",
      action: () => history.push(RoutesEnum.ORG_CHART)
    });
  }
  if (userHas(AuthoritiesEnum.AI_PROMPTS_READ)) {
    options.push({
      id: 7,
      name: /*#__PURE__*/React.createElement(React.Fragment, null, t("UserDropdown.aiPrompts"), /*#__PURE__*/React.createElement(Icon, {
        src: "encrypted",
        color: "primary",
        s: {
          ml: 1
        }
      })),
      icon: "chat",
      action: () => history.push(RoutesEnum.AI_PROMPTS)
    });
  }
  if (userHas(AuthoritiesEnum.COSTS_READ)) {
    options.push({
      id: 8,
      name: /*#__PURE__*/React.createElement(React.Fragment, null, t("UserDropdown.costExplorer"), /*#__PURE__*/React.createElement(Icon, {
        src: "encrypted",
        color: "primary",
        s: {
          ml: 1
        }
      })),
      icon: "savings",
      action: () => history.push(RoutesEnum.COST_EXPLORER)
    });
  }
  if (userHas(AuthoritiesEnum.FOOTPRINTS_READ)) {
    options.push({
      id: 9,
      name: /*#__PURE__*/React.createElement(React.Fragment, null, t("UserDropdown.footprints"), /*#__PURE__*/React.createElement(Icon, {
        src: "encrypted",
        color: "primary",
        s: {
          ml: 1
        }
      })),
      icon: "footprint",
      action: () => history.push(RoutesEnum.FOOTPRINTS)
    });
  }
  options.push({
    id: 10,
    name: t("UserDropdown.logOut"),
    icon: "log-out",
    action: () => dispatch(authActionCreators.loggedOut())
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    handler: /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 3,
      template: "2.85rem auto",
      align: "center"
    }, /*#__PURE__*/React.createElement(Avatar, {
      user: user,
      size: 10,
      s: {
        mr: 3
      }
    }), /*#__PURE__*/React.createElement(StyledGridCell, null, /*#__PURE__*/React.createElement(StyledText, {
      element: "span",
      display: "block",
      fontSize: 3.5
    }, user.firstName, " ", user.lastName), /*#__PURE__*/React.createElement(StyledText, {
      fontSize: 3.5,
      element: "span",
      display: "block",
      color: "textSecondary"
    }, user.company?.name))),
    handlerProps: {
      color: "translucent"
    },
    fullWidth: true
  }, _ref2 => {
    let {
      isOpen,
      onItemClick
    } = _ref2;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, options.map(option => /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: e => {
        onItemClick();
        option.action(e);
      },
      key: option.id
    }, /*#__PURE__*/React.createElement(Icon, {
      src: option.icon,
      s: {
        mr: 3
      },
      color: colors.text.secondary
    }), option.name)));
  }), /*#__PURE__*/React.createElement(Modal, {
    open: statusOpen
  }, /*#__PURE__*/React.createElement(ProfileStatusUpdateModal, {
    onClose: () => setStatusOpen(false)
  })));
};
export default UserDropdown;